// extracted by mini-css-extract-plugin
export default {"menuPageContainer":"MenuPage_menuPageContainer__cK-eL","menuPageContent":"MenuPage_menuPageContent__SQ5+3"};